import { Link } from 'react-router-dom';
import type { Language } from '../../types';
import { _t } from '../../lib/i18n';
import { LEGAL_FROM_PATH_KEY, legalPath } from '../../lib/legalPages';

type VisitingCardA11yFooterProps = {
  lang: Language;
  tenantSlug: string;
};

/**
 * Discreet link to the tenant accessibility statement — legal minimum on /c
 * without the full storefront footer or a11y FAB.
 */
export function VisitingCardA11yFooter({ lang, tenantSlug }: VisitingCardA11yFooterProps) {
  if (!tenantSlug) return null;

  return (
    <nav
      id="visiting-card-a11y-footer"
      aria-label={_t('legal.navLabel', lang)}
      className="border-t border-stone-200/80 pt-3 pb-1 text-center"
    >
      <Link
        id="link-visiting-card-accessibility"
        to={legalPath('accessibility', tenantSlug)}
        className="text-[10px] leading-snug text-stone-500 underline-offset-2 hover:underline"
        onClick={() => {
          try {
            sessionStorage.setItem(
              LEGAL_FROM_PATH_KEY,
              `${window.location.pathname}${window.location.search}`,
            );
          } catch {
            /* ignore */
          }
        }}
      >
        {_t('visitingCard.a11yLink', lang)}
      </Link>
    </nav>
  );
}
